import Rainbow1 from '../../../media/Apartement/Rainbow Spring/Rainbow Spring (1).webp'
import Rainbow2 from '../../../media/Apartement/Rainbow Spring/Rainbow Spring (2).webp'
import Rainbow3 from '../../../media/Apartement/Rainbow Spring/Rainbow Spring (3).webp'
import Rainbow4 from '../../../media/Apartement/Rainbow Spring/Rainbow Spring (4).webp'


const Rainbowimages =[
Rainbow1,Rainbow2,Rainbow3,Rainbow4
]

export default Rainbowimages;